import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import VehicleModelsTableContainer from '../../../modules/vehicleModels/components/VehicleModelsTableContainer';
import { useParams } from 'react-router-dom';
import { hasPermission } from '../../../utils/HelperFunctions';

const VehicleModels = () => {
  const { t } = useTranslation();
  const { id } = useParams()

  const { apiData, apiDataLoading, searchEle, paginationEle } = useModuleTableHelpers({
    route: `admin/makes/${id}/models`,
    queryKey: "models",
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.models'),
    withPagination: true
  });

  const tableHeaders = [
    { label: t('image') },
    { label: t('name') },
    { label: t('hidden') },
    hasPermission(['variants.show']) && { label: t('variants'), customClass: 'actions_col' },
    hasPermission(['models.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ].filter(Boolean);

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="vehicles-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">
          {searchEle}
        </div>
      </ListHeader>
      <VehicleModelsTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_models_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default VehicleModels;
